import React from 'react';
import statusConverter from 'utils/statusConverter';
import { batteryToText } from 'utils/utils';

export const columnSetter = (moduleScn, flag) => {
  const columns = [
    {
      Header: 'No',
      accessor: 'rnum',
    },
    {
      Header: '설비번호',
      accessor: 'areaNo',
    },
    {
      Header: '설비명',
      accessor: 'areaNm',
    },
    {
      Header: '감지기No.',
      accessor: 'modelNm',
    },
    {
      Header: (
        <span>
          독성가스(ppm)
        </span>
      ),
      accessor: 'h2s',
    },
    {
      Header: (
        <span>
          이산화탄소(ppm)
        </span>
      ),
      accessor: 'co2',
    },
    {
      id: 'status',
      Header: () => <div>상태</div>,
      Cell: ({ row }) => statusConverter(row.original.status),
    },
    {
      id: 'Battery',
      Header: () => <div>Battery(%)</div>,
      Cell: ({ row }) => batteryToText(row.original.battery),
    },
    {
      Header: '측정시간',
      accessor: 'regDate',
    },
  ];

  return columns;
};
